import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { HttpOptionsFactory } from '../../../models/http/http-options-factory'
import { StateDescription } from '../../../models/state-description'
import { StateMachine } from '../../../models/state-machine'
import { UrlCollection } from '../../../url-collection'

@Injectable({
  providedIn: 'root'
})
export class EntityStateService {
  constructor(private http: HttpClient) {}

  getCurrentState(stateMachineInstanceType: string, stateMachineInstanceId: number): Observable<StateDescription> {
    return this.http.get<StateDescription>(
      UrlCollection.Statemachine.CURRENT_STATE(stateMachineInstanceType, stateMachineInstanceId),
      new HttpOptionsFactory().addAcceptJson().addContentTypeJson().build()
    )
  }

  next(stateMachineInstanceType: string, stateMachineInstanceId: number, transitionId: number) {
    return this.http.post(
      UrlCollection.Statemachine.NEXT(),
      {
        stateMachineInstanceType: stateMachineInstanceType,
        stateMachineInstanceId: stateMachineInstanceId,
        transitionId: transitionId
      },
      new HttpOptionsFactory().addAcceptJson().addContentTypeJson().build()
    )
  }

  getStates(hrid: string): Observable<StateMachine> {
    return this.http.post<StateMachine>(
      UrlCollection.Statemachine.GET_STATES(),
      { hrid: hrid },
      new HttpOptionsFactory().addAcceptJson().addContentTypeJson().build()
    )
  }
}
